/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_medicalInstitution_responseImportOfficeCsv } from '../models/api_medicalInstitution_responseImportOfficeCsv';
import type { api_officialAnnouncement_responseExecOfficialAnnouncement } from '../models/api_officialAnnouncement_responseExecOfficialAnnouncement';
import type { api_organization_requestUpdateOrganizationCryptoKey } from '../models/api_organization_requestUpdateOrganizationCryptoKey';
import type { api_organization_responseCreateSystemAdminRequestUser } from '../models/api_organization_responseCreateSystemAdminRequestUser';
import type { api_organization_responseUpdateOrganizationCryptoKey } from '../models/api_organization_responseUpdateOrganizationCryptoKey';
import type { api_portalOffice_requestDeleteOldAddressBookData } from '../models/api_portalOffice_requestDeleteOldAddressBookData';
import type { api_portalOffice_requestPubAllPortalOffice } from '../models/api_portalOffice_requestPubAllPortalOffice';
import type { api_portalOffice_responseCreateSystemAdminStaffs } from '../models/api_portalOffice_responseCreateSystemAdminStaffs';
import type { api_portalOffice_responseDeleteOldAddressBookData } from '../models/api_portalOffice_responseDeleteOldAddressBookData';
import type { api_portalOffice_responseImportMarronForAddressBook } from '../models/api_portalOffice_responseImportMarronForAddressBook';
import type { api_portalOffice_responseImportOfficeCsvForAddressBook } from '../models/api_portalOffice_responseImportOfficeCsvForAddressBook';
import type { api_portalOffice_responsePubAllPortalOffice } from '../models/api_portalOffice_responsePubAllPortalOffice';
import type { api_portalOfficeSchedule_requestPubAllPortalOfficeSchedule } from '../models/api_portalOfficeSchedule_requestPubAllPortalOfficeSchedule';
import type { api_portalOfficeSchedule_requestPubIbowBillings } from '../models/api_portalOfficeSchedule_requestPubIbowBillings';
import type { api_portalOfficeSchedule_requestPubIbowCalendarEvents } from '../models/api_portalOfficeSchedule_requestPubIbowCalendarEvents';
import type { api_portalOfficeSchedule_requestPubIbowStaffs } from '../models/api_portalOfficeSchedule_requestPubIbowStaffs';
import type { api_portalOfficeSchedule_requestPubIbowStaffShifts } from '../models/api_portalOfficeSchedule_requestPubIbowStaffShifts';
import type { api_portalOfficeSchedule_requestPubIbowVisitSchedules } from '../models/api_portalOfficeSchedule_requestPubIbowVisitSchedules';
import type { api_portalOfficeSchedule_responseCreateEditableSchedules } from '../models/api_portalOfficeSchedule_responseCreateEditableSchedules';
import type { api_portalOfficeSchedule_responsePubAllPortalOfficeSchedule } from '../models/api_portalOfficeSchedule_responsePubAllPortalOfficeSchedule';
import type { api_portalOfficeSchedule_responsePubIbowBillings } from '../models/api_portalOfficeSchedule_responsePubIbowBillings';
import type { api_portalOfficeSchedule_responsePubIbowCalendarEvents } from '../models/api_portalOfficeSchedule_responsePubIbowCalendarEvents';
import type { api_portalOfficeSchedule_responsePubIbowStaffs } from '../models/api_portalOfficeSchedule_responsePubIbowStaffs';
import type { api_portalOfficeSchedule_responsePubIbowStaffShifts } from '../models/api_portalOfficeSchedule_responsePubIbowStaffShifts';
import type { api_portalOfficeSchedule_responsePubIbowVisitSchedules } from '../models/api_portalOfficeSchedule_responsePubIbowVisitSchedules';
import type { api_portalPatient_responseCreateInitPortalPatient } from '../models/api_portalPatient_responseCreateInitPortalPatient';
import type { api_requestCard_responseBulkSetPortalStaff } from '../models/api_requestCard_responseBulkSetPortalStaff';
import type { api_requestCard_responseStopExpiredPatientAutoUpdate } from '../models/api_requestCard_responseStopExpiredPatientAutoUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BatchService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Import office csv from GCS
     * GCSにアップロードされた事業所CSVをDBに取り込むバッチ(CloudSchedulerからのみ起動可能)
     * @returns api_medicalInstitution_responseImportOfficeCsv responseImportOfficeCsv
     * @throws ApiError
     */
    public getMedicalInstitutionImportOfficeCsv(): CancelablePromise<api_medicalInstitution_responseImportOfficeCsv> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/medical_institution/import_office_csv',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Exec OfficialAnnouncement
     * 運営からのお知らせの配信を実行するバッチ(CloudSchedulerからのみ起動可能)
     * @returns api_officialAnnouncement_responseExecOfficialAnnouncement responseExecOfficialAnnouncement
     * @throws ApiError
     */
    public getOfficialAnnouncementExec(): CancelablePromise<api_officialAnnouncement_responseExecOfficialAnnouncement> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/official_announcement/exec',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create RequestUser for system admin each Organization
     * 既存の事業所に管理ログイン用のRequestUserを作成するバッチ
     * @returns api_organization_responseCreateSystemAdminRequestUser responseCreateSystemAdminRequestUser
     * @throws ApiError
     */
    public getOrganizationCreateSystemAdmin(): CancelablePromise<api_organization_responseCreateSystemAdminRequestUser> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organization/create_system_admin',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Organization's Crypto Key
     * 紹介側組織の暗号化キーを更新するバッチ
     * @returns api_organization_responseUpdateOrganizationCryptoKey responseUpdateOrganizationCryptoKey
     * @throws ApiError
     */
    public getOrganizationUpdateCryptoKey({
        body,
    }: {
        /**
         * requestUpdateOrganizationCryptoKey
         */
        body: api_organization_requestUpdateOrganizationCryptoKey,
    }): CancelablePromise<api_organization_responseUpdateOrganizationCryptoKey> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organization/update_crypto_key',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create PortalStaff for syste admin each PortalOffice
     * 既存の事業所に管理ログイン用のPortalStaffを作成するバッチ
     * @returns api_portalOffice_responseCreateSystemAdminStaffs responseCreateSystemAdminStaffs
     * @throws ApiError
     */
    public getPortalOfficeCreateSystemAdmin(): CancelablePromise<api_portalOffice_responseCreateSystemAdminStaffs> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office/create_system_admin',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Old Address Book Data
     * 更新日時が指定日時以前の古い住所録データを削除するバッチ
     * @returns api_portalOffice_responseDeleteOldAddressBookData responseDeleteOldAddressBookData
     * @throws ApiError
     */
    public getPortalOfficeDeleteOldAddressBookData({
        body,
    }: {
        /**
         * requestDeleteOldAddressBookData
         */
        body: api_portalOffice_requestDeleteOldAddressBookData,
    }): CancelablePromise<api_portalOffice_responseDeleteOldAddressBookData> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office/delete_old_address_book_data',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Import marron data from GCS
     * GCSにアップロードされたまろんデータを住所録データとしてDBに取り込むバッチ(CloudSchedulerからのみ起動可能)
     * @returns api_portalOffice_responseImportMarronForAddressBook responseImportMarronForAddressBook
     * @throws ApiError
     */
    public getPortalOfficeImportMarronDataForAddressBook(): CancelablePromise<api_portalOffice_responseImportMarronForAddressBook> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office/import_marron_data_for_address_book',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Import office csv from GCS
     * GCSにアップロードされた事業所CSVを住所録データとしてDBに取り込むバッチ(CloudSchedulerからのみ起動可能)
     * @returns api_portalOffice_responseImportOfficeCsvForAddressBook responseImportOfficeCsvForAddressBook
     * @throws ApiError
     */
    public getPortalOfficeImportOfficeCsvForAddressBook(): CancelablePromise<api_portalOffice_responseImportOfficeCsvForAddressBook> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office/import_office_csv_for_address_book',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Pub All Portal Offices to Engine
     * 全てのポータルオフィスをエンジンにpubするバッチ
     * @returns api_portalOffice_responsePubAllPortalOffice responsePubAllPortalOffice
     * @throws ApiError
     */
    public getPortalOfficePubAll({
        body,
    }: {
        /**
         * requestPubAllPortalOffice
         */
        body: api_portalOffice_requestPubAllPortalOffice,
    }): CancelablePromise<api_portalOffice_responsePubAllPortalOffice> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office/pub_all',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Search filter from schedule-engine
     * 編集可能な手動スケジュールを作成するバッチ(CloudSchedulerからのみ起動可能)
     * @returns api_portalOfficeSchedule_responseCreateEditableSchedules responseCreateEditableSchedules
     * @throws ApiError
     */
    public getPortalOfficeScheduleCreateEditable(): CancelablePromise<api_portalOfficeSchedule_responseCreateEditableSchedules> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office_schedule/create_editable',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Pub All Portal Office Schedules to Engine
     * 全てのポータルオフィスのスケジュールをエンジンにpubするバッチ
     * @returns api_portalOfficeSchedule_responsePubAllPortalOfficeSchedule responsePubAllPortalOfficeSchedule
     * @throws ApiError
     */
    public getPortalOfficeSchedulePubAll({
        body,
    }: {
        /**
         * requestPubAllPortalOfficeSchedule
         */
        body: api_portalOfficeSchedule_requestPubAllPortalOfficeSchedule,
    }): CancelablePromise<api_portalOfficeSchedule_responsePubAllPortalOfficeSchedule> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office_schedule/pub_all',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Pub Ibow Billings to Engine
     * iBow請求情報をエンジンにpubするバッチ
     * @returns api_portalOfficeSchedule_responsePubIbowBillings responsePubIbowBillings
     * @throws ApiError
     */
    public getPortalOfficeSchedulePubIbowBillings({
        body,
    }: {
        /**
         * requestPubIbowBillings
         */
        body: api_portalOfficeSchedule_requestPubIbowBillings,
    }): CancelablePromise<api_portalOfficeSchedule_responsePubIbowBillings> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office_schedule/pub_ibow_billings',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Pub Ibow Calendar Events to Engine
     * 全てのiBowカレンダーイベントをエンジンにpubするバッチ
     * @returns api_portalOfficeSchedule_responsePubIbowCalendarEvents responsePubIbowCalendarEvents
     * @throws ApiError
     */
    public getPortalOfficeSchedulePubIbowCalendarEvents({
        body,
    }: {
        /**
         * requestPubIbowCalendarEvents
         */
        body: api_portalOfficeSchedule_requestPubIbowCalendarEvents,
    }): CancelablePromise<api_portalOfficeSchedule_responsePubIbowCalendarEvents> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office_schedule/pub_ibow_calendar_events',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Pub Ibow Staff Shifts to Engine
     * 全てのiBow職員シフトをエンジンにpubするバッチ
     * @returns api_portalOfficeSchedule_responsePubIbowStaffShifts responsePubIbowStaffShifts
     * @throws ApiError
     */
    public getPortalOfficeSchedulePubIbowStaffShifts({
        body,
    }: {
        /**
         * requestPubIbowStaffShifts
         */
        body: api_portalOfficeSchedule_requestPubIbowStaffShifts,
    }): CancelablePromise<api_portalOfficeSchedule_responsePubIbowStaffShifts> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office_schedule/pub_ibow_staff_shifts',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Pub Ibow Staffs to Engine
     * 全てのiBow職員をエンジンにpubするバッチ
     * @returns api_portalOfficeSchedule_responsePubIbowStaffs responsePubIbowStaffs
     * @throws ApiError
     */
    public getPortalOfficeSchedulePubIbowStaffs({
        body,
    }: {
        /**
         * requestPubIbowStaffs
         */
        body: api_portalOfficeSchedule_requestPubIbowStaffs,
    }): CancelablePromise<api_portalOfficeSchedule_responsePubIbowStaffs> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office_schedule/pub_ibow_staffs',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Pub Ibow Visit Schedules to Engine
     * 全てのiBow訪問予定をエンジンにpubするバッチ
     * @returns api_portalOfficeSchedule_responsePubIbowVisitSchedules responsePubIbowVisitSchedules
     * @throws ApiError
     */
    public getPortalOfficeSchedulePubIbowVisitSchedules({
        body,
    }: {
        /**
         * requestPubIbowVisitSchedules
         */
        body: api_portalOfficeSchedule_requestPubIbowVisitSchedules,
    }): CancelablePromise<api_portalOfficeSchedule_responsePubIbowVisitSchedules> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_office_schedule/pub_ibow_visit_schedules',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Init Portal Patient
     * 患者関連の新規テーブルに初期データを投入するバッチ
     * @returns api_portalPatient_responseCreateInitPortalPatient responseCreateInitPortalPatient
     * @throws ApiError
     */
    public getPortalPatientCreateInit(): CancelablePromise<api_portalPatient_responseCreateInitPortalPatient> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/portal_patient/create_init',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * PortalStaff Buld Set
     * 既読だが担当者が未設定の紹介依頼カードに担当者を一括で設定するバッチ(CloudSchedulerからのみ起動可能)
     * @returns api_requestCard_responseBulkSetPortalStaff responseBulkSetPortalStaff
     * @throws ApiError
     */
    public getRequestCardBulkSetPortalStaff(): CancelablePromise<api_requestCard_responseBulkSetPortalStaff> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/request_card/bulk_set_portal_staff',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Stop Expired Patient Auto Update
     * 自動更新期限が切れた利用者の自動更新を停止するバッチ
     * @returns api_requestCard_responseStopExpiredPatientAutoUpdate responseStopExpiredPatientAutoUpdate
     * @throws ApiError
     */
    public getRequestCardStopExpiredPatientAutoUpdate(): CancelablePromise<api_requestCard_responseStopExpiredPatientAutoUpdate> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/request_card/stop_expired_patient_auto_update',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
